<script setup lang="ts">
import { useCoursesStore } from '~~/stores/courses'
import { useMessageStore } from '~~/stores/message'

withDefaults(
  defineProps<{
    show?: boolean
  }>(),
  {
    show: false
  }
)

const emits = defineEmits(['cancel'])
const { addCdnToUrl } = useFormatUrlCdn()

const messageStore: Record<string, any> = useMessageStore()
const coursesStore = useCoursesStore()
const courseDetail = computed(() => coursesStore.state.courseDetail)

const getUrl = computed(() => window?.location?.href)

const shareOnSocial = (type: string) => {
  let url = null
  switch (true) {
    case type === 'facebook':
      url = `https://www.facebook.com/sharer/sharer.php?u=${getUrl.value}`
      break
    case type === 'linkedin':
      url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
        getUrl.value
      )}`
      break
    case type === 'twitter':
      url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        courseDetail.value?.data?.title
      )}&url=${encodeURIComponent(getUrl.value)}`
      break
    case type === 'email':
      url = `mailto:?subject=${encodeURIComponent(
        courseDetail.value?.data?.title
      )}&body=${encodeURIComponent(getUrl.value)}`
      break
    default:
      url = `https://api.whatsapp.com/send?text=${encodeURIComponent(
        getUrl.value
      )}`
      break
  }
  openNewWindow(url)
}

const openNewWindow = (url) => {
  const newWindow = window.open(url, '_blank', 'width=600,height=400')
  if (newWindow) {
    newWindow.focus()
  } else {
    messageStore.triggerMessage({
      type: 'error',
      body: 'Please allow pop-ups for this website'
    })
  }
}

const copyClipboard = (url: string) => {
  const textArea = document.createElement('textarea')
  textArea.value = url
  document.body.appendChild(textArea)
  textArea.select()
  document.execCommand('copy')
  document.body.removeChild(textArea)

  messageStore.triggerMessage({
    type: 'success',
    body: 'Copied!'
  })
}
</script>

<template>
  <ClientOnly>
    <AtomsModal
      :visible="show"
      :width="556"
      centered
      :closable="false"
      @cancel="emits('cancel')"
    >
      <div class="kursus-detail__share">
        <div class="share-title">Bagikan</div>
        <div class="share-info">
          <div class="share-info__thumbnail">
            <nuxt-img
              :src="addCdnToUrl(courseDetail?.data?.thumbnailURL)"
              :alt="courseDetail?.data?.title"
              loading="lazy"
              :title="courseDetail?.data?.title"
            />
          </div>
          <div class="share-info__description">
            {{ courseDetail?.data?.title }}
          </div>
        </div>
        <div class="share-social">
          <div class="share-social__item">
            <img
              src="~/assets/images/social/share-wa.png"
              alt="share-whatsapp"
              @click="shareOnSocial('whatsapp')"
            />
          </div>
          <div class="share-social__item">
            <img
              src="~/assets/images/social/share-linkedin.png"
              alt="share-linkedin"
              @click="shareOnSocial('linkedin')"
            />
          </div>
          <div class="share-social__item">
            <img
              src="~/assets/images/social/share-facebook.png"
              alt="share-facebook"
              @click="shareOnSocial('facebook')"
            />
          </div>
          <div class="share-social__item">
            <img
              src="~/assets/images/social/share-x.png"
              alt="share-x"
              @click="shareOnSocial('twitter')"
            />
          </div>
          <div class="share-social__item">
            <img
              src="~/assets/images/social/share-email.png"
              alt="share-email"
              @click="shareOnSocial('email')"
            />
          </div>
          <div class="share-social__item">
            <a @click="copyClipboard(getUrl)">
              <img
                src="~/assets/images/social/share-link.png"
                alt="share-link"
              />
            </a>
          </div>
        </div>
      </div>
    </AtomsModal>
  </ClientOnly>
</template>

<style lang="scss">
@use './styles.scss';
</style>
